export const INTERVIEW_ROLE_OPTIONS = [
    // { value: "Software Engineer", label: "Software Engineer" },
    // { value: "Data Scientist", label: "Data Scientist" },
    // { value: "Product Engineer", label: "Product Engineer" },
    // { value: "UX Designer", label: "UX Designer" },
    // { value: "Other", label: "Other" },
    { value: "software-engineer", label: "Software Engineer" },
    { value: "product-manager", label: "Product Manager" },
    { value: "data-scientist", label: "Data Scientist" },
    { value: "ux-designer", label: "UX Designer" },
    { value: "marketing", label: "Marketing" },
    { value: "sales", label: "Sales" },
    { value: "finance", label: "Finance" },
    { value: "operations", label: "Operations" },
    { value: "human-resources", label: "Human Resources" },
    { value: "other", label: "Other" },
];

export const normalizeInterviewRole = (value) => {
    const normalized = String(value || "").trim();
    if (!normalized || normalized === "user") return "";
    return normalized;
};

export const hasInterviewRole = (value) =>
    normalizeInterviewRole(value).length > 0;

export const getInterviewRoleLabel = (value) => {
    const normalized = normalizeInterviewRole(value);
    if (!normalized) return "";
    const match = INTERVIEW_ROLE_OPTIONS.find(
        (role) => role.value === normalized
    );
    return match?.label || normalized;
};
